import { createFileRoute } from '@tanstack/react-router';
import Settings from '~/containers/Settings';

export const Route = createFileRoute('/settings/$category')({
  component: Settings,
});
